import BaseBarsChartsStrategy from './BaseBarsChartsStrategy'
import {PaperOrientation} from '../../../../pdf/constants'
import {ChartType} from '../../../constants'
import {
    getMaxValuesOnFitPageWithoutImageProperty,
    getMaxValuesOnPageWithoutImageProperty,
    getNeededImageDimensions
} from '../ChartPDFDefinitionPartsConstructors'

export default class HorBarsChartStrategy extends BaseBarsChartsStrategy {
    constructor() {
        super(ChartType.HORIZONTAL_BAR)
    }

    adjustDataParameters(pagesData, pdfPrintParameters) {
        if (this._isDoublePageDataPortion(pdfPrintParameters)) {
            // need to split data by image and data
            return pagesData.reduce((res, cur) => {
                // page with image
                res.push({
                    image: cur.image
                })
                // page with data
                res.push({
                    data: cur.data
                })
                return res
            }, [])
        } else {
            return super.adjustDataParameters(pagesData, pdfPrintParameters)
        }
    }

    _isDoublePageDataPortion(pdfPrintParameters) {
        return pdfPrintParameters.paperOrientation === PaperOrientation.LANDSCAPE && this._needToShowTable(pdfPrintParameters)
    }

    addPageDataWithDataList(ddBuilder, docDefinition, pageData, pdfPrintParameters, pageIndex) {
        const pageNumber = pageIndex + 1
        if (this._isDoublePageDataPortion(pdfPrintParameters)) {
            if (pageNumber % 2 !== 0) { // odd page with image, even page with data
                ddBuilder.addOnlyImageToPage(docDefinition, pageData.image)
            } else {
                ddBuilder.addOnlyTableToPage(
                    docDefinition, pageData.data, pdfPrintParameters.showListOfDataValues,
                    pdfPrintParameters.showListOfPercentValues, pdfPrintParameters.fitDataToOnePage
                )
            }
        } else {
            super.addPageDataWithDataList(ddBuilder, docDefinition, pageData, pdfPrintParameters, pageIndex)
        }
    }

    addPageDataWithoutDataList(ddBuilder, docDefinition, pageData, pdfPrintParameters, nPages) {
        if (pdfPrintParameters.paperOrientation === PaperOrientation.LANDSCAPE) {
            if (pageData.secondImage || nPages > 1)
                ddBuilder.addDoubleImagesHorizontal(docDefinition, pageData.firstImage, pageData.secondImage)
            else
                ddBuilder.addOnlyImageToPage(docDefinition, pageData.firstImage) // show single image only if single page
        } else {
            super.addPageDataWithoutDataList(ddBuilder, docDefinition, pageData, pdfPrintParameters, nPages)
        }
    }

    getMaxValuesOnPage({paperOrientation, paperSize, showHeaderOnEachPage}) {
        if (paperOrientation === PaperOrientation.LANDSCAPE) {
            return getMaxValuesOnPageWithoutImageProperty({paperOrientation, paperSize, chartType: this.chartType, withHeader: showHeaderOnEachPage})
        } else {
            return super.getMaxValuesOnPage({paperOrientation, paperSize, showHeaderOnEachPage})
        }
    }

    getMaxValuesOnFitPage({paperOrientation, paperSize, showHeaderOnEachPage}) {
        if (paperOrientation === PaperOrientation.LANDSCAPE) {
            return getMaxValuesOnFitPageWithoutImageProperty({paperOrientation, paperSize, chartType: this.chartType, withHeader: showHeaderOnEachPage})
        } else {
            return super.getMaxValuesOnFitPage({paperOrientation, paperSize, showHeaderOnEachPage})
        }
    }

    getTotalNumberOfPages(lengthOfDataList, pdfPrintParameters) {
        if (this._isDoublePageDataPortion(pdfPrintParameters)) {
            if (pdfPrintParameters.fitDataToOnePage) { // TODO need to rename property :)
                return 2
            } else {
                return super.getTotalNumberOfPages(lengthOfDataList, pdfPrintParameters) * 2
            }
        } else {
            return super.getTotalNumberOfPages(lengthOfDataList, pdfPrintParameters)
        }
    }

    getChartImageDimensions(lengthOfDataList, pdfPrintParameters) {
        if (pdfPrintParameters.paperOrientation === PaperOrientation.LANDSCAPE && !this._needToShowTable(pdfPrintParameters)) {
            // barsOnPage means barsOnChart
            // if landscape and without table we can show singe image to full page if there are no another images
            let isDoubleImages = !pdfPrintParameters.fitDataToOnePage && pdfPrintParameters.barsOnPage < lengthOfDataList
            return getNeededImageDimensions(pdfPrintParameters.paperOrientation, pdfPrintParameters.paperSize, this.chartType, isDoubleImages)
        } else {
            return super.getChartImageDimensions(lengthOfDataList, pdfPrintParameters)
        }
    }
}



// WEBPACK FOOTER //
// ./web/js/reports/charts/pdfgenerator/doStrategy/HorBarsChartStrategy.js